// 200 English sentences the host can pick from (quick match picks randomly).
// No proper nouns so translations stay comparable across languages.

export const SENTENCES: string[] = [
	"The weather is nice today.",
	"I drink coffee every morning.",
	"My brother plays the guitar.",
	"The cat sleeps on the sofa.",
	"We walk to school together.",
	"She reads books at night.",
	"The train arrives at noon.",
	"I forgot my keys again.",
	"Children love playing outside.",
	"This soup tastes delicious.",
	"My father works in a bank.",
	"The birds sing in the morning.",
	"I need to buy new shoes.",
	"The movie starts at eight.",
	"He swims in the lake every summer.",
	"Our house has a red door.",
	"The baby is sleeping quietly.",
	"They travel by bus to work.",
	"I enjoy listening to music.",
	"The garden needs more water.",
	"My sister speaks three languages.",
	"Dinner is ready in ten minutes.",
	"The dog chased the ball.",
	"Winter is colder than autumn.",
	"I always brush my teeth twice.",
	"The moon looks bright tonight.",
	"She writes letters to her grandmother.",
	"We planted flowers in spring.",
	"The market opens early.",
	"His bicycle is faster than mine.",
	"I take the bus on rainy days.",
	"The teacher explains the lesson clearly.",
	"Fresh bread smells wonderful.",
	"My friends live near the park.",
	"The river flows through the valley.",
	"He fixed the broken window.",
	"I study before breakfast.",
	"The stars shine over the mountains.",
	"She sings in the church choir.",
	"Our team won the match.",
	"The phone rings during dinner.",
	"I prefer tea over coffee.",
	"The museum closes on Mondays.",
	"Clouds cover the sky.",
	"My uncle grows vegetables.",
	"The clock on the wall is slow.",
	"We cook rice every evening.",
	"The horse runs across the field.",
	"I lost my umbrella yesterday.",
	"The library is quiet after noon.",
	"Snow falls softly in January.",
	"Her laughter fills the room.",
	"The fish swim near the rocks.",
	"I clean my room on Saturdays.",
	"The bridge crosses the old canal.",
	"He paints pictures of the sea.",
	"Breakfast is the best meal.",
	"The wind blows from the north.",
	"My neighbors are very kind.",
	"The apples ripen in September.",
	"I ride my bike to the station.",
	"The kitchen smells like cinnamon.",
	"Grandmother tells wonderful stories.",
	"The waves crash on the shore.",
	"We watch the sunset together.",
	"The letter arrived this morning.",
	"My shoes are wet from rain.",
	"The children built a sandcastle.",
	"Coffee grows in warm places.",
	"The elevator is out of order.",
	"I practice piano after dinner.",
	"The fox hides in the forest.",
	"Our street is lined with trees.",
	"The bakery sells sweet rolls.",
	"He carries a heavy backpack.",
	"The lake freezes in winter.",
	"I feed the ducks at noon.",
	"Her dress is blue and white.",
	"The concert lasts two hours.",
	"Bees visit the lavender flowers.",
	"My grandfather walks every evening.",
	"The suitcase is under the bed.",
	"We celebrate the new year together.",
	"The mountain peak is covered in snow.",
	"I answer emails in the afternoon.",
	"The rooster crows at dawn.",
	"Fresh vegetables cost less here.",
	"The puppy follows me everywhere.",
	"She waters the plants daily.",
	"The tunnel goes under the mountain.",
	"I borrow books from the library.",
	"The fireworks light up the sky.",
	"My cousin studies medicine.",
	"The boat sails at sunrise.",
	"We pick berries in the forest.",
	"The carpet feels soft.",
	"He repairs old clocks.",
	"The desert is hot during the day.",
	"I hang my coat by the door.",
	"The choir practices on Thursdays.",
	"Rain drips from the roof.",
	"My aunt bakes bread on Sundays.",
	"The path leads to the waterfall.",
	"Students gather in the courtyard.",
	"The candle burns slowly.",
	"I charge my phone at night.",
	"The grapes taste sour this year.",
	"Our cat hates water.",
	"The plane lands in fog.",
	"She folds the laundry neatly.",
	"The fountain sparkles in sunlight.",
	"I write notes during meetings.",
	"The owl hunts at night.",
	"Autumn leaves cover the sidewalk.",
	"My laptop needs charging.",
	"The chef seasons the soup.",
	"We climb the hill behind town.",
	"The mirror hangs in the hallway.",
	"Thunder echoes across the valley.",
	"I sort my photos monthly.",
	"The sheep graze on the hillside.",
	"Her voice sounds gentle.",
	"The truck delivers packages early.",
	"Ice melts quickly in the sun.",
	"I stretch before running.",
	"The castle stands above the village.",
	"My keyboard is dusty.",
	"The waiter brings fresh water.",
	"Shadows grow long in the evening.",
	"We recycle paper and glass.",
	"The kite flies high above the beach.",
	"I prefer window seats on planes.",
	"The gardener trims the hedges.",
	"Salt dissolves in warm water.",
	"My watch runs five minutes fast.",
	"The violin sounds beautiful alone.",
	"Fog settles over the harbor.",
	"We toast bread for breakfast.",
	"The squirrel stores nuts for winter.",
	"I lock the gate every night.",
	"The painting hangs crooked.",
	"Cool air flows through the window.",
	"My friend collects stamps.",
	"The train station smells of rain.",
	"She arranges flowers beautifully.",
	"The ladder leans against the wall.",
	"I save money for trips.",
	"Crickets chirp after dark.",
	"The tailor measures carefully.",
	"Our mailbox is painted green.",
	"The waves wash away footprints.",
	"I peel oranges in one piece.",
	"The bell rings three times.",
	"Dew covers the grass at dawn.",
	"My brother fixes bicycles.",
	"The attic holds old photographs.",
	"We grill corn in summer.",
	"The compass points north.",
	"I water the tomatoes at dusk.",
	"The staircase creaks at night.",
	"Her scarf matches her gloves.",
	"Fishermen return before sunset.",
	"The oven heats slowly.",
	"I organize my desk weekly.",
	"Pine trees line the road.",
	"The kettle whistles loudly.",
	"My sister draws comic strips.",
	"The harvest begins in October.",
	"We navigate by the stars.",
	"The sponge absorbs water quickly.",
	"I wear boots in muddy weather.",
	"The chimney smokes in winter.",
	"Light reflects off the wet street.",
	"My neighbor plays jazz records.",
	"The basket holds ripe plums.",
	"We follow the trail markers.",
	"The curtain flutters in the breeze.",
	"I sharpen pencils before class.",
	"The vineyard sits on the hillside.",
	"Frost patterns cover the window.",
	"My father reads newspapers aloud.",
	"The ferry crosses twice daily.",
	"We stack firewood in autumn.",
	"The alarm clock rings at six.",
	"I rinse dishes with hot water.",
	"Butterflies dance around the roses.",
	"The cellar stays cool in summer.",
	"My grandmother knits sweaters.",
	"The rope swing hangs from the oak.",
	"We measure flour carefully.",
	"The harbor lights glow at night.",
	"I dust the shelves on Fridays.",
	"Wildflowers bloom in May.",
	"The drawer sticks in humid weather.",
	"My uncle repairs fishing nets.",
	"Echoes repeat in empty halls.",
	"The sprinkler starts at dawn.",
	"We label jars of jam.",
	"The moon rises over the rooftops.",
	"I fall asleep reading novels.",
];
